<template>
  <div class="input-group ">
    <div v-if="prependText" class="input-group-prepend">
      <div class="input-group-text">{{ prependText }}</div>
    </div>
    <select class="custom-select" :style="{ width }" v-model="selectedValue">
      <option
        v-for="item of optionList"
        :key="item.value"
        :value="item.value"
        >{{ item.name }}</option
      >
    </select>
  </div>
</template>

<script>
export default {
  name: 'Selector',
  props: {
    prependText: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: 'auto'
    },
    value: {
      required: true
    },
    optionList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectedValue: this.value
    };
  },
  watch: {
    selectedValue(val) {
      this.$emit('onValueChange', val);
    }
  }
};
</script>

<style lang="scss" scoped>
.input-group-text {
  background-color: initial;
  border: none;
  font-weight: 600;
  color: $text-black;
}
.custom-select {
  flex: 0 1 auto;
}
</style>
